<template>
  <b-row id="welcome" class="mt-2">
    <b-col>
      <p>Welcome to the <strong>ACDN Management Tool.</strong></p>
      <p>To use this tool, you must first log in. Click the "Login" link above to get started.</p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Welcome',
};
</script>
